import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { SharedFarmModule } from 'src/app/components/shared-farm/shared-farm.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgbDropdownModule, NgbTooltipModule, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { SolicitacaoCompraComponent } from './solicitacao-compra/solicitacao-compra.component';
import { FormsSolicitacaoCompraComponent } from './solicitacao-compra/forms-solicitacao-compra/forms-solicitacao-compra.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    SolicitacaoCompraComponent,
    FormsSolicitacaoCompraComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    SharedFarmModule,
    NgSelectModule,
    CurrencyMaskModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbAccordionModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'pt'
    })
  ],
  exports: [
    SolicitacaoCompraComponent
  ]
})
export class ComprasModule { }
